import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  //Disable console logs
  if(environment.production) {
    if(window.location.hostname !== 'localhost'){
      window.console.log = function() {}
      window.console.info = function() {}
      window.console.warn = function() {}
      window.console.time = function() {}
      window.console.timeLog = function() {}
      window.console.timeEnd = function() {}
    }
  }
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
